import * as React from "react";
const SvgFiRrGlassWhiskey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-glass-whiskey_svg__a)">
      <path
        fill="#062147"
        d="M23.993 4.298A3 3 0 0 0 21.007 1h-18a3.01 3.01 0 0 0-2.218.981 3 3 0 0 0-.77 2.299l1.325 14.186a4.98 4.98 0 0 0 4.979 4.536h11.275a4.986 4.986 0 0 0 4.976-4.504zm-21.725-.97a.99.99 0 0 1 .739-.327h18a.98.98 0 0 1 .742.327 1 1 0 0 1 .254.771l-.99 9.9H2.936L2.01 4.093a.98.98 0 0 1 .256-.766zM17.598 21H6.322a2.98 2.98 0 0 1-2.986-2.72l-.213-2.279h17.69l-.23 2.298A2.99 2.99 0 0 1 17.598 21"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-glass-whiskey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGlassWhiskey;
